import script from "./unitOverdueHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./unitOverdueHistory.vue?vue&type=script&setup=true&lang=js"

import "./unitOverdueHistory.vue?vue&type=style&index=0&id=30c6de37&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30c6de37"]])

export default __exports__